export const CATEGORIES = [
  { id: "spirituality", label: "Spirituality & Wisdom", icon: "🕉️",  description: "Ancient wisdom for modern life" },
  { id: "coding",       label: "Coding & Dev",           icon: "💻",  description: "Build real-world projects" },
  { id: "manifestation", label: "Mindset & Manifestation", icon: "✨", description: "The mindset behind making it happen" },
  { id: "sports", label: "Sports & Culture", icon: "⚽", description: "The stories behind the game" },
];

export const COURSES = [
  {
    id: 1,
    category: "spirituality",
    title: "100 Learnings from Krishna",
    subtitle: "Timeless wisdom from the Bhagavad Gita for modern life",
    price: 11,
    originalPrice: 199,
    pages: 12,
    rating: 4.9,
    reviews: 9,
    tag: "BESTSELLER",
    accentColor: "#7c3aed",
    thumbnail: {
      image: "/course-images/Krishna-100-learnings.webp",
      gradient: "linear-gradient(135deg, #1e0a4a 0%, #3b0d8a 50%, #6d28d9 100%)",
      emoji: "🕉️",
      pattern: "radial",
      accent: "#a78bfa",
    },
    description:
      "Discover 100 life-changing lessons drawn from Lord Krishna's teachings in the Bhagavad Gita. Each learning is presented in a simple, modern context that you can apply immediately — whether in career, relationships, or personal growth.",
    whatYouGet: [
      "More than 20 pages of beautifully written PDF",
      "100 distilled wisdom lessons",
      "Full audio narration included",
      "Applicable to modern everyday life",
    ],
    topics: [
      "Duty & Purpose (Dharma)",
      "Detachment from Results",
      "Overcoming Fear & Doubt",
      "Leadership & Decision Making",
      "Mind & Emotion Management",
      "The Path to Inner Peace",
    ],
    featured: true,
    driveFileId: "1V4d5Vs3Mgos0oa6VYVThC9V1bQu41-DG",
    audioFileId: "",
    audioUrl: "https://pub-e8f3e318b1b046dc9162eb2490b75f66.r2.dev/Krishna_100_learn_audio.mp3"
  },
  {
    id: 2,
    category: "coding",
    title: "NumPy & pandas",
    subtitle: "From arrays to DataFrames — a practical guide to data analysis in Python",
    price: 11,
    originalPrice: 199,
    pages: 16,
    rating: 5,
    reviews: 1,
    tag: "NEW",
    accentColor: "#0e7490",
    thumbnail: {
      image: "/course-images/numpy_pandas.webp",
      gradient: "linear-gradient(135deg, #0f172a 0%, #1e3a8a 55%, #0e7490 100%)",
      emoji: "📊",
      pattern: "radial",
      accent: "#38bdf8",
    },
    description:
      "Master the two libraries at the heart of data analysis in Python. This compact, hands-on course takes you from NumPy arrays to pandas DataFrames with runnable code, comparison tables, and two tear-out cheatsheets you'll actually keep.",
    whatYouGet: [
      "16-page beautifully designed PDF",
      "Runnable code with inline outputs",
      "Two quick-reference cheatsheets",
      "Beginner-friendly, reference-ready",
    ],
    topics: [
      "Creating & Inspecting Arrays",
      "Indexing, Slicing & Boolean Masks",
      "Broadcasting & Aggregation",
      "Series & DataFrames",
      "Cleaning Messy Data",
      "Grouping, Joining & Pivoting",
    ],
    featured: true,
    driveFileId: "1E_Ee6Y9xYmOp4cfb3kvBec4CpAhKJ7GW",
    audioFileId: "",
    audioUrl: ""
  },
  {
    id: 3,
    category: "coding",
    title: "PyTorch",
    subtitle: "From tensors to trained neural networks — a practical guide to deep learning",
    price: 11,
    originalPrice: 199,
    pages: 17,
    rating: 5,
    reviews: 1,
    tag: "NEW",
    accentColor: "#ea580c",
    thumbnail: {
      image: "/course-images/pytorch.webp",
      gradient: "linear-gradient(135deg, #1a0a02 0%, #7c2d12 50%, #ea580c 100%)",
      emoji: "🔥",
      pattern: "radial",
      accent: "#fb923c",
    },
    description:
      "Go from tensors to trained neural networks with this compact, practical guide to deep learning in Python. Covers autograd, building models, training loops, and saving your work — with runnable code and a tear-out cheatsheet you'll actually keep.",
    whatYouGet: [
      "17-page beautifully designed PDF",
      "Runnable code with inline outputs",
      "Full quick-reference cheatsheet",
      "Beginner-friendly, reference-ready",
    ],
    topics: [
      "Tensors & GPU Acceleration",
      "Autograd & Automatic Differentiation",
      "Building Models with nn.Module",
      "Loss Functions & Optimizers",
      "The Training Loop",
      "Datasets, Evaluation & Saving",
    ],
    featured: true,
    driveFileId: "1d5yTeUD_oYcdP5OJhGKuPPAhx-Tl0TZK",
    audioFileId: "",
    audioUrl: ""
  },
  {
    id: 4,
    category: "manifestation",
    title: "The Science Behind the Wish",
    subtitle: "Where quantum reality meets the Law of Attraction",
    price: 11,
    originalPrice: 199,
    pages: 18,
    rating: 5,
    reviews: 1,
    tag: "NEW",
    accentColor: "#c026d3",
    thumbnail: {
      image: "/course-images/law-of-attraction-course.webp",
      gradient: "linear-gradient(135deg, #0a0118 0%, #2e1065 50%, #c026d3 100%)",
      emoji: "✨",
      pattern: "radial",
      accent: "#e879f9",
    },
    description:
      "Curious about the Law of Attraction but tired of empty hype? This guide unpacks the mindset behind manifestation — using quantum physics as metaphor and inspiration, and grounding the rest in the real psychology of attention, belief, and action. You'll learn to get clear on what you actually want, focus your mind on it, and take aligned steps to make it happen. Less magic, more method.",
    whatYouGet: [
      "Beautifully designed PDF",
      "Practical intention-setting exercises",
      "Daily visualization & focus practices",
      "A clear-eyed, honest take on the Law of Attraction",
    ],
    topics: [
      "What the Law of Attraction Really Is",
      "Quantum Physics as Metaphor — and Where the Analogy Ends",
      "The Psychology of Focus & Belief",
      "Clarifying & Setting Powerful Intentions",
      "Visualization & Mental Rehearsal",
      "Turning Wishes into Aligned Action",
    ],
    featured: true,
    driveFileId: "1HBa7E_gJ0dJQednbjHU-V_h-m2KBsTF7",
    audioFileId: "https://pub-e8f3e318b1b046dc9162eb2490b75f66.r2.dev/Law%20of%20Attraction%20Audio.mp3",
    audioUrl: ""
  },
  {
    id: 5,
    category: "sports",
    title: "Why India Bleeds Blue-White and Yellow-Green",
    subtitle: "The untold story of India's love affair with Argentina and Brazil",
    price: 11,
    originalPrice: 199,
    pages: 14,
    rating: 4.8,
    reviews: 7,
    tag: "NEW",
    accentColor: "#0ea5e9",
    thumbnail: {
      image: "/course-images/india-arg-br.webp",
      gradient: "linear-gradient(135deg, #0c2e4a 0%, #1d8fc9 45%, #2a9d4f 100%)",
      emoji: "⚽",
      pattern: "radial",
      accent: "#38bdf8",
    },
    description:
      "Every four years, streets in Bengal, Kerala, and beyond erupt in blue-white and yellow-green — for two nations thousands of miles away. This is the story of why millions of Indians, whose own team has never reached a World Cup, pour their hearts into Argentina and Brazil. From Maradona's magic to Pelé's legacy, from colonial history to small-town carnival fandom, discover the roots of one of football's most fascinating rivalries.",
    whatYouGet: [
      "More than 14 pages of beautifully written PDF",
      "A deep dive into India's football obsession",
      "Full audio narration included",
      "Stories from Bengal, Kerala, and beyond",
    ],
    topics: [
      "The Maradona Effect: How Argentina Won Bengal's Heart",
      "Brazil's Samba Football & the Pelé Legacy",
      "Kolkata's Great Football Divide",
      "Kerala's Giant Cut-Outs & Carnival Fandom",
      "Colonial Roots of Indian Football Passion",
      "World Cup Fever Without a Home Team",
    ],
    featured: true,
    driveFileId: "1_yltl48aYo_KaTQF0BIJlYt6yC3V1Lq1",
    audioFileId: "",
    audioUrl: "https://pub-e8f3e318b1b046dc9162eb2490b75f66.r2.dev/India-arg-br.mp3"
  }
];

export const STATS = [
  { value: "10+",   label: "Students Enrolled" },
  { value: "4.9★",  label: "Average Rating" },
  { value: "₹11",    label: "Starting Price" },
  { value: "100%",  label: "Instant Delivery" },
];

export const TESTIMONIALS = [
  {
    name: "Priya Sharma", role: "Marketing Manager, Bengaluru", avatar: "PS",
    text: "100 Learnings from Krishna genuinely changed how I approach challenges at work. The lesson on detachment from results alone transformed my relationship with stress.",
    course: "100 Learnings from Krishna", rating: 5,
  },
  {
    name: "Rohit Nair", role: "Freelancer, Mumbai", avatar: "RN",
    text: "I've read many books on the Gita but this PDF breaks it down in a way that actually sticks. Finished it in one sitting. The audio version is a bonus — I listen on my commute.",
    course: "100 Learnings from Krishna", rating: 5,
  },
  {
    name: "Ananya Gupta", role: "College Student, Delhi", avatar: "AG",
    text: "Each of the 100 lessons is short and to the point. I read one lesson every morning. It sets the tone for the entire day. Truly life-changing content.",
    course: "100 Learnings from Krishna", rating: 5,
  },
  {
    name: "Karthik Reddy", role: "Finance Analyst, Hyderabad", avatar: "KR",
    text: "Was skeptical at first but the modern context made everything relatable. The lesson on fearless action helped me make a career decision I had been delaying for months.",
    course: "100 Learnings from Krishna", rating: 5,
  },
];

export const formatPrice  = (p) => `₹${p}`;
export const getDiscount  = (orig, price) => Math.round(((orig - price) / orig) * 100);